import styled from "styled-components"

export const FavouriteCardContainer = styled.div`
  /* border: red solid 2px; */
  z-index: 2000;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0);
  /* display: flex; */
  font-family: "NotoSans-Regular";
  font-weight: 200;
  opacity: ${props => props.visible};

  transition: opacity 0.2s ease;
`
export const FloorplanHolder = styled.div`
  position: absolute;
  pointer-events: initial;
  background-color: rgba(0, 0, 0, 0);
  background-color: white;
  flex-direction: column;
  display: flex;
  /* flex: 7; */
  width: 70%;
  height: 100%;
  background-size: cover;
`

export const InfoHolder = styled.div`
  position: absolute;
  left: 70%;
  /* padding-right: 2%; */
  padding: 1.5%;
  overflow: hidden;
  /* flex-basis: max-content; */
  background-color: #fff;
  display: flex;
  flex-direction: column;
  /* flex: 3; */
  width: 30%;
  height: 100%;
`

export const FavButtonContainer = styled.div`
  cursor: auto;
`
export const ButtonContainer = styled.div`
  flex: 1;
  min-height: 50px;
`

export const TitleHolder = styled.div`
  flex: 1;
  margin-right: 7%;
  display: flex;
  flex-direction: column;
  text-align: right;
`
export const DimsHolder = styled.div`
  align-items: flex-end;
  display: flex;
  flex: 1;
  flex-basis: 100px;

  margin: 2% 0%;
`
export const ElevationHolder = styled.div`
  width: 100%;
  height: 100%;
  margin: 6% 2%;
  padding: 2% 5%;
  justify-content: center;
  align-items: flex-end;
`

export const HorizontalHolder = styled.div`
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
  overflow: hidden;
`

export const ButtonHolder = styled.div`
  /* border: black solid 2px; */
  /* height: 100%; */
  flex: 1;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
`
export const Button = styled.div`
  margin: 5% 0%;

  cursor: pointer;
  pointer-events: initial;
  z-index: 200000000;
`

export const Disclaimer = styled.div`
  /* border: black solid 2px; */
  flex: 0.2;
  p {
    padding: 0% 10%;
    color: #3f1c50;
    font-size: 40%;
    text-align: left;
    /* letter-spacing: 1%; */
    /* line-height: 1%; */
  }
`
export const FloorTitle = styled.h2`
  padding: 0;
  margin: 2% 0%;
  font-family: "Lora";
  font-size: 2rem;
  font-weight: 100;
  color: #897794;
`
export const PlotTitle = styled.h1`
  padding: 0;
  margin: 2% 0%;

  color: #3f1c50;
  font-size: 3rem;

  font-weight: 100;
`
export const BedTitle = styled.h4`
  padding: 0;
  margin: 2% 0%;

  margin: 0;
  color: #3f1c50;
  font-size: 1.75rem;
  font-weight: 100;
`

export const FullScreenFloor = styled.div`
  pointer-events: initial;
  position: absolute;
  z-index: 1000000000;
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;

  object-fit: contain;
  img {
    .flipped {
      -webkit-transform: scaleX(-1);
      transform: scaleX(-1);
    }
    object-fit: contain;
    height: 100%;
    /* border: red solid 2px; */
  }
`

export const Header = styled.div`
  background-color: #897794;
  flex: 2.7;
`

export const FloorPlan = styled.div`
  height: 100%;
  padding: 2%;
  flex: 6;

  display: flex;
  justify-content: center;
  align-items: center;

  img {
    .flipped {
      -webkit-transform: scaleX(-1);
      transform: scaleX(-1);
    }
    object-fit: contain;
  }
`

export const ViggnetteHolder = styled.div`
  flex: 2;
  background-image: url("${process.env
    .PUBLIC_URL}/assets/textures/gallery/residencs/img-2a.jpg");
  background-size: cover;
`
